import { render, staticRenderFns } from "./EasyOrdersCreation.vue?vue&type=template&id=fd2f0912&scoped=true"
import script from "./EasyOrdersCreation.vue?vue&type=script&lang=js"
export * from "./EasyOrdersCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2f0912",
  null
  
)

export default component.exports